


























































import { Component, Vue } from 'vue-property-decorator';

import _keyBy from 'lodash.keyby';
import _map from 'lodash.map';
import _get from 'lodash.get';

@Component
export default class Support extends Vue {
  name = process.env.VUE_APP_NAME;
  version = process.env.VERSION;

  support_groups = [
    {
      id: 'general',
      name: 'General',
      topics: [
        {
          id: 'quick_start',
          name: 'Quick Start',
        },
        { id: 'technology', name: 'Technology' },
        { id: 'contact', name: 'Contact' },
      ],
    },
    {
      id: 'interfaces',
      name: 'Interfaces',
      topics: [
        { id: 'video', name: 'Video' },
        { id: 'tags', name: 'Tags' },
        { id: 'tracks', name: 'Tracks' },
      ],
    },
    {
      id: 'advanced',
      name: 'Advanced',
      topics: [
        { id: 'hotkeys', name: 'Hotkeys' },
        { id: 'api', name: 'API' },
      ],
    },
  ];

  support_groups_index = _keyBy(
    _map(this.support_groups, (group: any) => {
      return {
        ...group,
        topics: _keyBy(group.topics, 'id'),
      };
    }),
    'id'
  );

  get selectedGroup() {
    return this.$route.params.group || 'general';
  }

  get selectedTopic() {
    return this.$route.params.topic || 'quick_start';
  }

  get getTopic() {
    return _get(this.support_groups_index, [
      this.selectedGroup,
      'topics',
      this.selectedTopic,
    ]);
  }

  get activeComponent() {
    let component = 'GeneralQuickStart.vue';

    if (this.getTopic) {
      if (this.getTopic.component) {
        component = this.getTopic.component;
      } else {
        component = `${
          this.support_groups_index[this.selectedGroup].name
        }${this.support_groups_index[this.selectedGroup].topics[
          this.selectedTopic
        ].name.replace(' ', '')}`;
      }
    }

    return () =>
      import(
        /* webpackChunkName: "support-topic" */ `../components/Support/${component}`
      );
  }

  created() {
    if (!this.getTopic) {
      this.$router.replace({
        name: 'error',
        params: {
          code: '404',
          redirectedFrom: 'support',
        },
      });
    }
  }

  changeRoute(group_topic: any) {
    const [group_id, topic_id] = group_topic.split('|');
    this.$router
      .push({
        name: 'support',
        params: {
          group: group_id,
          topic: topic_id,
        },
      })
      .catch((error) => {
        if (error.name != 'NavigationDuplicated') {
          throw error;
        }
      });
  }
}
